
















































































































































































































































































































































































































































































































import Vue from 'vue'
import Modal from '@/components/Modal'
import ManageCasters from './ManageCasters'
import StreamOutputs from '@/components/StreamOutputs'
import ManageCastFolders from '@/components/ManageCastFolders'
import ManageWidgets from '@/components/ManageWidgets'
import CastInputSelector from '@/components/CastInputSelector'
import { DatePicker, Option, Popover, Select, Step, Steps } from 'element-ui'
import { between, minLength, required } from 'vuelidate/lib/validators'
import helpers from '../../helpers'
import fb from '@/firebase'
import env from '../../env'
import { cloneDeep, sortBy, pickBy } from 'lodash'
import { DropdownOption } from '@/types/dropdownOption'
import { CollectionNames, KeyDict, SelectOption } from '@/types'
import { Cast, CustomRtmpDestination, DEFAULT_SUPPORT_LEVEL, InvitedCaster, MIXER_DEFAULT_GOP, SupportLevel } from '@/types/casts'
import { CastTemplate } from '@/types/casttemplates'
import { Release, WATERMARK_DEFAULT } from '@/store/types'
import { AbilityAction, AbilitySubject } from '@/abilitiesByRole'
import { TranscodingRegion } from '@/types/admin'
import WRTCLoadbalancer from '@/classes/WRTCLoadbalancer'
import { WowzaStat } from '@/types/wowza'
import SubscribeWowzaStats from '@/mixins/SubscribeWowzaStats'
import { Feature } from '@/featureFlags/featureFlags'
import { TeamGroup } from '@/types/teams'
import SubscribeRelease from '@/mixins/SubscribeRelease'
import moment from 'moment' // Do we still need this? Their website states it's "a legacy project in maintenance mode"
import { Region } from '@/types/ops'

const LARGE_MACHINE_TYPE = 'c5_18xlarge'
const NORMAL_MACHINE_TYPE = 'm5_12xlarge'

enum CreateEditMode {
  Create = 'create',
  Copy = 'copy',
  Edit = 'edit'
}

export default Vue.extend({
  name: 'CreateEditCast',
  mixins: [SubscribeWowzaStats, SubscribeRelease],
  props: {
    inputCast: {
      type: Object as () => Cast,
      required: true
    },
    team: {
      type: String
    },
    teamMembers: {
      type: Array
    },
    streams: {
      type: Object
    },
    folders: {
      type: Array
    },
    castProperties: {
      type: Object
    },
    templates: {
      type: Array as () => CastTemplate[]
    }
  },
  computed: {
    release (): Release|null {
      return this.$store.direct.state.admin.release
    },
    teamVersion (): string {
      return this.$store.direct.state.team.team.version
    },
    ngcvpVersion (): string|null {
      if (this.release === null) return null
      const version = this.release.versions[this.teamVersion]
      return version?.ngcvp_version ?? null
    },
    isActiveCast (): boolean {
      return helpers.isActiveCast(this.editCast)
    },
    heavyDutyAllowed (): boolean {
      return this.$hasFeature(Feature.HEAVY_DUTY_AVAILABLE)
    },
    transcodingregions (): KeyDict<TranscodingRegion> {
      return this.$store.direct.state.admin.transcodingregions
    },
    wowzastats (): KeyDict<WowzaStat> {
      return this.$store.direct.state.opsmonitor.wowzastats
    },
    submitIsActive (): boolean {
      return this.submitStatus !== 'submitting' && (this.initCast || this.isCopyMode)
    },
    isCopyMode (): boolean {
      return !!this.editCast.copying
    },
    modalTitle (): string {
      if (this.isCopyMode) {
        return 'Copy Event'
      }
      return !!this.inputCast.name ? 'Edit Event' : 'Create New Event'
    },
    modalButton (): string {
      switch (this.mode) {
        case CreateEditMode.Create:
          return 'Create Event'
        case CreateEditMode.Copy:
          return 'Copy Event'
        default:
          return 'Update Event'
      }
    },
    buttonStatus (): boolean {
      let status = false
      if (this.editCast.name && this.editCast.name.length > 1) {
        status = true
      }
      return status
    },
    assetGroups (): KeyDict<boolean> {
      return (this.editCast.asset_groups) ? this.editCast.asset_groups : {}
    },
    supportLevels (): DropdownOption[] {
      const levels: DropdownOption[] = []
      if (this.$can(AbilityAction.Do, AbilitySubject.Ops)) {
        levels.push({ name: 'Silver', key: SupportLevel.Silver })
      }

      return levels.concat([
        { name: 'Gold', key: SupportLevel.Gold },
        { name: 'Platinum', key: SupportLevel.Platinum }
      ])
    },
    regions (): DropdownOption[] {
      const r = {}
      Object.keys(this.castProperties).forEach(castPropertyId => {
        const castProperty = this.castProperties[castPropertyId]
        if (castProperty.type === 'region') {
          r[castProperty.name] = castPropertyId
        }
      })
      const sortedNames = Object.keys(r).sort()
      const regionlist: DropdownOption[] = []
      sortedNames.forEach((name: string) => {
        regionlist.push({ name: name, key: r[name] } as DropdownOption)
      })
      return regionlist
    },
    originalSupport (): string {
      const match = this.supportLevels.find(support => support.key === this.originalCast?.supportLevel)
      return match?.name ?? this.defaultSupportLevel
    },
    originalRegion (): string {
      if (!this.regions || !this.inputCast) return ''
      const match = this.regions.find(region => region.key === this.originalCast?.region)
      return match?.name ?? '--'
    },
    originalQuality (): string {
      if (!this.qualities || !this.inputCast) return ''
      const match = this.qualities.find(quality => quality.key === this.originalCast?.quality)
      return match?.name ?? '--'
    },
    qualities (): DropdownOption[] {
      const r = {}
      Object.keys(this.castProperties).forEach(castPropertyId => {
        const castProperty = this.castProperties[castPropertyId]
        if (castProperty.type === 'quality') {
          r[castPropertyId] = castProperty.name
        }
      })
      const sortedNames = Object.keys(r).sort()
      const qualitylist: DropdownOption[] = []
      sortedNames.forEach(key => {
        qualitylist.push({ name: r[key], key: key } as DropdownOption)
      })
      return qualitylist
    },
    framerates (): DropdownOption[] {
      const r = {}
      Object.keys(this.castProperties).forEach(castPropertyId => {
        const castProperty = this.castProperties[castPropertyId]
        if (castProperty.type === 'framerate') {
          r[castProperty.name] = castPropertyId
        }
      })
      const sortedNames = Object.keys(r).sort()
      const frameratelist: DropdownOption[] = []
      sortedNames.forEach(name => {
        frameratelist.push({ name: name, key: r[name] } as DropdownOption)
      })
      return frameratelist
    },
    resolution (): string {
      if (this.editCast === null || this.editCast.quality === undefined) {
        return ''
      }
      const resStr = this.editCast.quality.split('p')[0]
      return parseInt(resStr) + ''
    },
    fpsRounded (): number {
      const castFps = this.editCast.framerate.replace('Hz', '')
      let fps = parseFloat(castFps)
      if (Math.ceil(fps) <= 30) {
        fps = 30
      } else {
        fps = 60
      }
      return fps
    },
    formattedTemplates (): SelectOption[] {
      let templates: SelectOption[] = []
      if(this.templates !== undefined){
        templates = this.templates.map(template => {
          return { key: template.id, label: template.name }
        })
      }
      templates = sortBy(templates, [o => o.label.toLowerCase()])
      templates.unshift({ key: 'default', label: 'New Blank Event' })
      return templates
    },
    loadedTemplate (): CastTemplate | null {
      const template = this.templates.find(template => template.id === this.selectedTemplate)
      return template !== undefined ? template : null
    },
    kenv (): string {
      return env.environment
    },
    canUpdateSupportLevel (): boolean {
      if (this.$can(AbilityAction.Do, AbilitySubject.Ops)) return true
      if (this.mode === CreateEditMode.Edit) return false
      if (this.isCopyMode) return false
      return true
    },
    shouldShowGopWarning (): boolean {
      if (this.originalGop !== this.editCast.gop_size && this.hadOriginalOutputs) return true
      return false
    },
    teamGroupOptions (): TeamGroup[] {
      return this.$store.direct.state.team.teamGroups ?? []
    },
    sortedTeamGroups (): TeamGroup[] {
      return sortBy(this.teamGroupOptions, group => group.name.toLowerCase())
    },
    isEditMode (): boolean {
      return this.mode === CreateEditMode.Edit
    },
    defaultSupportLevel (): SupportLevel {
      return this.$store.direct.getters.team.defaultSupportLevel
    }
  },
  data: () => ({
    submitStatus: '',
    mode: CreateEditMode.Create,
    activeSection: 0,
    originalCast: {} as Cast | undefined,
    selectedTemplate: 'default',
    templateLoaded: false,
    hasvalidinputs: true,
    initCast: false,
    editCast: {
      name: '',
      input_streams: {},
      event_id: '',
      asset_groups: {},
      start_date: new Date(),
      end_date: new Date(),
      preview_scenes: {},
      deleted: false,
      record_isos: false,
      team_id: '',
      region: 'us-east',
      quality: '0720p006000',
      framerate: '30Hz',
      srt: false,
      supportLevel: DEFAULT_SUPPORT_LEVEL,
      pendingPlatinumRequest: false,
      platinumApproved: false,
      largemachine: false,
      create_event: true,
      invited_casters: {},
      online_sessions: {},
      custom_rtmp_destinations: {} as KeyDict<CustomRtmpDestination>,
      talk_back: {},
      widgets: {},
      template: '',
      watermark: WATERMARK_DEFAULT,
      gop_size: MIXER_DEFAULT_GOP,
      teamGroups: [] as string[]
    } as Cast,
    originalGop: MIXER_DEFAULT_GOP,
    hadOriginalOutputs: false
  }),
  validations: {
    editCast: {
      name: {
        required,
        minLength: minLength(2)
      },
      gop_size: {
        required,
        between: between(1,6)
      },
      start_date: {
        required
      },
      end_date: {
        required,
        minValue (value) {
          const castStartDate: Date = this.editCast.start_date
          const startDate = moment(castStartDate, moment.ISO_8601)
          const endDate = moment(value, moment.ISO_8601)
          const validFormat = startDate.isValid() && endDate.isValid()
          if (validFormat === false) {
            return false
          }

          // Should we enforce a minimum duration?
          const now = moment()
          return startDate.isBefore(endDate) && endDate.isAfter(now)
        },
        maxValue (value) {
          // Note: Using `new Date(value).getTime() < new Date(this.editEvent.start_date).getTime() + 24 * 3600 * 1000`
          // here in the custom validation function, for some reason causes type script errors:
          // `Property 'xxx' does not exist on type 'CombinedVueInstance<Vue, { submitStatus: string; ...`
          const maxDateTime: number = this.editCast.start_date.getTime() + 24 * 3600 * 1000
          return new Date(value).getTime() < maxDateTime
        }
      }
    }
  },
  mounted () {
    fb.db.collection(CollectionNames.TEAMS).doc(this.team).get().then(doc => {
      try {
        const data = doc.data()
        if (this.mode === CreateEditMode.Create) {
          try {
            if (data?.default_srt === true) {
              this.editCast.srt = true
            }
          } catch {}
          try {
            if (data?.default_region) {
              for (const regidx in this.regions) {
                const reg = this.regions[regidx]
                if (data.default_region === reg.key) {
                  this.editCast.region = data.default_region
                }
              }
            }
          } catch {}
        }
      } catch {}
    }).catch(error => {
      console.error('Create edit event error ', error)
    })
  },
  created () {
    // only show copy layout when actually copying,
    // otherwise allow editing of copied cast
    if (this.inputCast.copying) {
      this.mode = CreateEditMode.Copy
      this.editCast = cloneDeep(this.inputCast)
      this.originalCast = (this.editCast.originalCast) ? JSON.parse(this.editCast.originalCast) : undefined
      this.initCast = true
      this.editCast.watermark = (this.originalCast) ? this.originalCast.watermark : WATERMARK_DEFAULT
      this.editCast.supportLevel = (this.originalCast) ? this.originalCast.supportLevel : this.defaultSupportLevel
      this.editCast.event_id = ''
    }

    if (this.mode !== CreateEditMode.Copy && !!this.inputCast.name) {
      this.mode = CreateEditMode.Edit
      const tmpCast: Cast = cloneDeep(this.inputCast)
      // FIXME: Which code causes the undefined `start_time` to be added to the `source_streams`. Because when
      //        EventListItem::loadCasts() loads the casts from the DB, they don't have it yet.
      for (const stream of Object.values(tmpCast.source_streams)) {
        if (stream.hasOwnProperty('start_time') && stream.start_time === undefined) {
          console.log('Deleting undefined start_time!')
          delete stream.start_time
        }
      }
      this.editCast = tmpCast
      this.initCast = true
    }

    // Convert from Firestore timestamp or string to Date
    // TODO: Why does a cast get moved to archived (in ops page) when we don't change to Date objects here?
    // TODO: We should ensure with TS and when fetching casts from DB that start/end_date is always a JS Date object.
    if (this.editCast.start_date.seconds !== undefined) {
      this.editCast.start_date = new Date(this.editCast.start_date.seconds * 1000)
    } else if (!(this.editCast.start_date instanceof Date)) {
      this.editCast.start_date = new Date(this.editCast.start_date)
    }
    if (this.editCast.end_date.seconds !== undefined) {
      this.editCast.end_date = new Date(this.editCast.end_date.seconds * 1000)
    } else if (!(this.editCast.end_date instanceof Date)) {
      this.editCast.end_date = new Date(this.editCast.end_date)
    }

    if (this.mode === CreateEditMode.Create) {
      this.editCast.start_date = new Date()
      this.editCast.end_date = moment(this.editCast.start_date).add(4, 'hours').toDate()
    } else if (this.mode === CreateEditMode.Copy) {
      const now = new Date()
      if (this.editCast.start_date < now) {
        this.editCast.start_date = now
      }
    }

    this.editCast.gop_size = this.editCast.gop_size ?? MIXER_DEFAULT_GOP
    this.editCast.team_id = this.team
    this.updateOriginalGopInfo()
  },
  methods: {
    checkPlatinum (requestedSupportLevel: string) {
      if (requestedSupportLevel !== SupportLevel.Platinum || this.editCast.platinumApproved) {
        this.editCast.pendingPlatinumRequest = false
        return
      }

      const startDate = moment(this.editCast.start_date?.seconds ? this.editCast.start_date?.seconds * 1000 : this.editCast.start_date)
      const needsApproval = startDate.isBefore(moment().add(2, 'days'))
      this.editCast.pendingPlatinumRequest = needsApproval
    },
    validOutputs (): boolean {
      let valid = true
      Object.keys(this.editCast.custom_rtmp_destinations || {}).forEach(outputKey => {
        if (outputKey && this.editCast.custom_rtmp_destinations![outputKey].url === '') {
          valid = false
        }
      })
      return valid
    },
    setValidNumberOfInputs (value: boolean) {
      this.hasvalidinputs = value
    },
    formSubmitted (): void {
      // TODO: $touch() basically only updates the $dirty value. But it doesn't run the validator functions again.
      //       For editCast.end_date we want this, because the current time might have already past the end date that
      //       was set previoulsy. How can we trigger the validator functions to run again in a clean way?
      //       Or should we just check the end-date here manually?
      // @ts-ignore
      this._computedWatchers.$v.run() // FIXME: Don't use "private" Vue method to force an update of the validators.
      this.$v.$touch()
      let outputValid = true
      Object.values(this.editCast.custom_rtmp_destinations || {}).forEach(output => {
        outputValid = outputValid && output.valid
      })
      // set/reset error status
      if (!this.hasvalidinputs) {
        this.submitStatus = 'ERROR'
        if (!this.isCopyMode) {
          this.activeSection = 1
        }
      } else if (this.$v.$invalid || !outputValid) {
        this.submitStatus = 'ERROR'
        this.activeSection = 0
      } else if (!this.validOutputs()) {
        this.submitStatus = 'ERROR'
        this.activeSection = 0
      } else if (this.submitStatus === 'ERROR') {
        this.submitStatus = ''
      }

      // submit unless error or already submitting
      if (this.submitStatus === '') {
        this.submitStatus = 'submitting'
        switch (this.mode) {
          case CreateEditMode.Copy:
          case CreateEditMode.Create:
            if (this.editCast.region !== null) {
              const castName = this.editCast.name
              const castProps = Object.assign({}, this.castProperties[this.editCast.region])
              delete castProps.name
              delete castProps.id

              const region = this.transcodingregions[castProps.transcodingregion]
              if (region !== undefined) {
                const balancer = new WRTCLoadbalancer()
                const wrtcserver = balancer.getServerUrlToStreamTo(region, this.wowzastats)
                if (wrtcserver !== undefined) castProps.wrtcserver = wrtcserver
              }
              this.editCast = {
                ...this.editCast,
                ...castProps,
                name: castName
              }
            }
            this.updatePresets()

            // Ensure that the start date is at least now
            if (this.editCast.start_date.getTime() < Date.now()) this.editCast.start_date = new Date()

            const nextAction = (this.editCast.copying) ? 'copyCast' : 'createCast'
            this.$emit(nextAction, this.editCast)
            break

          case CreateEditMode.Edit:
            this.$emit('updateCast', this.editCast)
            break
        }
      }
    },
    __appendPresets (presets: string[]) {
      this.editCast.presets = this.editCast.presets.concat(presets)
    },
    updatePresets () {
      if (this.editCast === undefined) return
      this.editCast.presets = []
      if (this.editCast.quality !== null) {
        const properties = this.castProperties[this.editCast.quality]
        if (properties !== undefined) this.__appendPresets(properties.presets)
      }
      if (this.editCast.framerate !== null) {
        const properties = this.castProperties[this.editCast.framerate]
        if (properties !== undefined) this.__appendPresets(properties.presets)
      }
      const machineType = this.editCast.largemachine ? LARGE_MACHINE_TYPE : NORMAL_MACHINE_TYPE
      let machinePresets = this.castProperties[machineType].presets
      const regionData = this.castProperties[this.editCast.region]
      if (regionData?.presets) this.__appendPresets(regionData?.presets)
      if (this.editCast.largemachine) {
        if (regionData?.largemachine_preset) machinePresets = regionData.largemachine_preset
      }
      if (machinePresets) this.__appendPresets(machinePresets)
      if (this.ngcvpVersion !== null) this.__appendPresets([this.ngcvpVersion])
    },
    formatCasters (casters) {
      this.editCast.invited_casters = pickBy(this.editCast.invited_casters, (caster) => caster.anonymous)
      for (const caster of casters) {
        this.editCast.invited_casters[caster] = new InvitedCaster({ userId: caster })
      }
    },
    formatFolders (folders) {
      this.editCast.asset_groups = {}
      for (const folder of folders) {
        this.editCast.asset_groups[folder] = true
      }
    },
    updateSelectedGroups (newGroups) {
      this.editCast.teamGroups = newGroups
    },
    changeLargeMachine () {
      this.$store.direct.dispatch.events.setEditCastLargeMachine(this.editCast.largemachine)
    },
    loadCastTemplate () {
      if (this.selectedTemplate === 'default') {
        this.initCast = true
      } else {
        let template: Partial<CastTemplate>|undefined = this.templates.find(template => template.id === this.selectedTemplate)
        if (template !== undefined) {
          template = Object.assign({}, template)
          delete template.id

          // Make sure we keep all properties reactive in case `template` doesn't have them. (CC-2607)
          // See also: https://vuejs.org/v2/guide/reactivity.html#For-Objects
          this.editCast = Object.assign({}, this.editCast, template as Cast)
          this.editCast.name = 'Instance of: ' + template.name
          this.editCast.watermark = template.watermark ?? WATERMARK_DEFAULT
          this.editCast.supportLevel = template.supportLevel ?? this.defaultSupportLevel
          this.editCast.platinumApproved = false

          if (!this.heavyDutyAllowed) this.editCast.largemachine = false
          this.templateLoaded = true
          this.initCast = true
          this.editCast.gop_size = this.editCast.gop_size !== undefined ? this.editCast.gop_size : MIXER_DEFAULT_GOP

          if (this.regions.find(item => item.key === this.editCast.region) === undefined) {
            const teamDefaultRegion = this.$store.direct.state.team.team.default_region
            if (teamDefaultRegion !== undefined && this.regions.find(item => item.key === teamDefaultRegion)) {
              this.editCast.region = teamDefaultRegion as Region
            } else if (this.regions.length > 0 && this.regions[0].key !== undefined) {
              this.editCast.region = this.regions[0].key as Region
            } else {
              console.warn('No regions available to assign to cast template.')
            }
          }
        }
        this.updateOriginalGopInfo()
      }
    },
    previousStep () {
      this.activeSection--
    },
    nextStep () {
      this.activeSection++
      console.log('nextStep', this.activeSection)
    },
    goToStep (step) {
      this.activeSection = step
    },
    hideModal () {
      this.$emit('closeModal')
    },
    widgetsChanged (widgets) {
      this.editCast.widgets = {
        ...widgets
      }
    },
    getObjectLength (paramObj: object): number {
      return Object.keys(paramObj).length
    },
    updateOriginalGopInfo (): void {
      this.originalGop = this.editCast.gop_size
      this.hadOriginalOutputs = Object.keys(this.editCast.custom_rtmp_destinations ?? {}).length > 0
    }
  },
  watch: {
    'editCast.custom_rtmp_destinations' (newValue: Cast) {
      if (!this.hadOriginalOutputs) return
      if (newValue !== undefined && Object.keys(newValue).length === 0) {
        this.hadOriginalOutputs = false
      }
    }
  },
  components: {
    Modal,
    ManageCasters,
    StreamOutputs,
    ManageCastFolders,
    ManageWidgets,
    CastInputSelector,
    'el-select': Select,
    'el-option': Option,
    'el-steps': Steps,
    'el-step': Step,
    'el-popover': Popover,
    'el-date-picker': DatePicker
  }
})
